import React, { Component } from 'react'
import style from './customizeAll.style'

// COMPONENTS
import { DishIcon } from '../app-icon/Icons'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Wrapper from '../wrapper'
import LogoHelpData from '../app-logo/logo-help'
import CustomizeAllForm from '../app-form/CustomizeAllForm'
import Snackbar from '@material-ui/core/Snackbar'

function Transition(props) {
  return <Slide direction="left" {...props} />
}

class CustomizeAll extends Component {
  state = {
    user: window.state.user,
    openModal: false,
    openSnakbar: false,
  }

  successData = status => {
    if (status === 'ok') {

      // Отправка события
      // window.dataLayer.push({'event': 'setupconversion'})

      this.timer = setTimeout(
        () =>
          this.setState({
            openModal: false,
            isFetching: false,
            openSnakbar: true,
          }),
        600
      )

    }
  }

  handleClickOpen = event => {
    event.preventDefault()
    this.setState({ openModal: true })
  }

  handleClose = () => {
    this.setState({ openModal: false, isFetching: false })
  }

  handleCloseSnakbar = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openSnakbar: false })
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/help/me'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }

      this.setState({
        isFetching: false,
      })
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        this.successData(status)
      })
      .catch(errors)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  render() {
    const { classes } = this.props
    const { openModal, openSnakbar } = this.state
    const { user } = window.state

    return (
      <div className={classes.box}>
        <div className={classes.description} onClick={this.handleClickOpen}>
          <DishIcon width={24} height={16} className={classes.icon} />
          <span className={classes.action}>{`Настройте все \n за меня!`}</span>
        </div>

        <Dialog
          fullScreen
          open={openModal}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          PaperProps={{
            classes: {
              root: this.props.classes.paper,
            },
          }}
        >
          <AppBar className={this.props.classes.appBar} elevation={0}>
            <Toolbar style={{ paddingTop: 16 }}>
              <LogoHelpData />
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
                style={{ marginLeft: 'auto' }}
              >
                <CloseIcon style={{ fill: '#fff' }} />
              </IconButton>
            </Toolbar>
          </AppBar>
          <div
            style={{
              maxWidth: 400,
              width: '100%',
              margin: '0 auto',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <header className={classes.modalTitle}>
              <DishIcon width={48} height={32} className={classes.modalIcon} />
              <h6
                style={{
                  fontFamily: 'Roboto',
                  fontSize: 24,
                  fontWeight: 'bold',
                  fontStyle: 'normal',
                  fontStretch: 'normal',
                  lineHeight: 'normal',
                  letterSpacing: 'normal',
                  textAlign: 'center',
                  color: 'rgb(0, 0, 0)',
                  margin: '0 0 24px 0',
                }}
              >
                Просто подайте заявку!
              </h6>
              <div className={classes.subTitle}>
                {`Мы свяжемся с вами в течение часа, \n выясним все подробности \n и настроим систему сами.`}
              </div>
            </header>
            <Wrapper
              shadow={1}
              style={{
                width: '100%',
                borderRadius: 8,
                overflow: 'hidden',
                padding: '40px 50px 50px 50px',
                backgroundColor: 'rgb(255, 255, 255)',
                fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
                lineHeight: 1.5,
              }}
            >
              <CustomizeAllForm
                onSubmit={this.handleSubmit}
                isFetching={this.state.isFetching}
                initialValues={{ email: user.email, phone: user.phone }}
              />
            </Wrapper>
          </div>
        </Dialog>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={openSnakbar}
          autoHideDuration={5000}
          onClose={this.handleCloseSnakbar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <span id="message-id">
              Заявка отправлена. Мы свяжемся с вами в течение часа.
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleCloseSnakbar}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    )
  }
}

export default style(CustomizeAll)
